import { digitsOnly } from "./contactMethods";

export const distinctPhoneName = (
  name: string | null | undefined,
  phone: string
) => {
  const trimmed = name?.trim();
  if (!trimmed) return undefined;
  const stripped = trimmed.replace(/[\s\-().+]/g, "");
  if (!stripped) return undefined;
  if (/^\d+$/.test(stripped) && digitsOnly(stripped) === digitsOnly(phone))
    return undefined;
  return trimmed;
};
